import React from "react"
import { useState, useEffect } from 'react'
import { useAuth } from "../contexts/AuthContext"
import { useHistory, Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import '../css/Profile.css'
import { db } from '../firebase'
import '../css/Base.css'
import ConnectionToast from "../components/ConnectionToast"
import Player from '../images/player.png'

export default function Profile() {

  const history = useHistory()
  const { currentUser, logout, deleteUser } = useAuth()
  const userEmail = currentUser.email;

  const [username, setUsername] = useState("");
  const [betsWon, setBetsWon] = useState(0);
  const [betsLost, setBetsLost] = useState(0);
  const [betsTotal, setBetsTotal] = useState(0);
  const [winpercentage, setWinpercentage] = useState(0);

  useEffect(() => {

    let userName = "";
    let BW = 0;
    let BL = 0;
    let BT = 0;
    let WP = 0;

    db.collection("Players").doc(`${currentUser.uid}`).get().then((user => {
      BW = user.data().betsWon
      BL = user.data().betsLost
      BT = user.data().totalBets
      WP = Math.round((user.data().betsWon / (user.data().betsWon + user.data().betsLost) * 100))


    })).then(() => {
      setBetsWon(BW)
      setBetsLost(BL)
      setBetsTotal(BT)
      setWinpercentage(WP)
    })

    db.collection("Players").doc(`${currentUser.uid}`).get().then((user => {
      userName = user.data().username
    }))
      .then(() => {
        setUsername(userName);
      })



    // OFFLINE ONLINE TOAST
    let connectionLostToast = document.getElementById('connectionLost')
    connectionLostToast.setAttribute('autohide', false)

    window.addEventListener('offline', function () {
      connectionLostToast.style.display = "block"
    });

    window.addEventListener('online', function () {
      connectionLostToast.style.display = "none"
    });

  })


  function handleLogOut(e) {
    e.preventDefault()
    logout();
    history.push('/login')
  }

  function handleDeleteProfile(e) {
    e.preventDefault()

    db.collection("Players").doc(`${currentUser.uid}`).delete().then(() => {
      deleteUser();
      history.push('/')
    })
  }

  function handleSaveUsername() {

    let nickname = document.getElementById("nicknameValue").value
    let span = document.getElementById("spanValidator")

    if (nickname.length <= 5) {
      span.removeAttribute('hidden');
      span.innerHTML = "Your new username must be greater than 5 characters long"
    }
    else {
      db.collection("Players").doc(`${currentUser.uid}`).set({
        username: nickname
      }, {
        merge: true
      }).then(() => {
        span.removeAttribute('hidden');
        span.innerHTML = "Username was changed successfuly"
      })
    }
  }

  return (
    <>
      <div className="divImagePlayer">
        <img className="imagePlayer" alt="a soccerplayer" src={Player} />
      </div>
      <ConnectionToast />
      <div className="row justify-content-md-center g-0 pt-3">
        <div className="row mt-5">
          <div className="offset-md-2 col-md-5">
            <Card className="viewport80" id="card-profile">
              <div className="card-header text-center">
                USER PROFILE
              </div>
              <div className="avatar">
                <img src='https://avataaars.io/?avatarStyle=Circle&topType=ShortHairTheCaesarSidePart&accessoriesType=Blank&hairColor=Platinum&facialHairType=Blank&clotheType=Hoodie&clotheColor=PastelBlue&eyeType=Default&eyebrowType=Default&mouthType=Default&skinColor=Light' className="avatarIMG" alt="avatar" />
              </div>
              <Card.Body>
                <div className="mt-4 mb-3">
                  <label className="form-label">Email</label> <br />
                  <label className="form-label">{userEmail}</label>
                </div>
                <div className="mb-3">
                  <label className="form-label">Username</label>
                  <input type="text" className="form-control" id="nicknameValue" placeholder={username} />
                </div>
                <span hidden id="spanValidator" className="text-danger" > BLA BLA BLA</span>
                <div className="mt-3 text-end">
                  <button className="btn btn-info" onClick={handleSaveUsername}>SAVE USERNAME</button>
                </div>
              </Card.Body>
            </Card>
          </div>
          <div className="col-md-5">
            <div className="row" id="rowProfile">
              <div className="col-md-11">
                <Card className="viewport35" id="card-profile" >
                  <div className="card-header text-center">
                    PERSONAL SCORE
                  </div>
                  <Card.Body className="text-end">
                    <ul className="list-group">
                      <li className="list-group-item-white d-flex justify-content-between align-items-center mb-2">
                        Bets Won
                        <span className="text-dark badge bg-info rounded-pill">{betsWon}</span>
                      </li>
                      <li className="list-group-item-white d-flex justify-content-between align-items-center mb-2">
                        Bets lost
                        <span className="text-dark badge bg-info rounded-pill">{betsLost}</span>
                      </li>
                      <li className="list-group-item-white d-flex justify-content-between align-items-center mb-2">
                        Score
                        <span className="text-dark badge bg-info rounded-pill">{betsWon * 10 - betsLost * 5}</span>
                      </li>
                      <li className="list-group-item-white d-flex justify-content-between align-items-center mb-3">
                        Total Bets
                        <span className="text-dark badge bg-info rounded-pill">{betsTotal}</span>
                      </li>
                      <li className="list-group-item-white d-flex justify-content-between align-items-center">
                        Winpercentage
                      </li>
                      <li className="list-group-item-white list-unstyled mt-2">
                        <div className="progress">
                          <div className="progress-bar progress-bar-striped bg-info text-dark fw-bold" role="progressbar" style={{ "width": `${winpercentage}%` }} aria-valuenow={winpercentage} aria-valuemin="0" aria-valuemax="100">{winpercentage} %</div>
                        </div>
                      </li>
                    </ul>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <div className="row" id="rowProfile">
              <div className="col-md-11">
                <Card className="viewport33" id="card-profile">
                  <div className="card-header text-center">
                    ACCOUNT SETTINGS
                  </div>
                  <Card.Body className="d-flex flex-column">
                    <button type="button" onClick={handleLogOut} className="btn btn-info mt-2 mb-2">LOG OUT</button>
                    <Link className="text-dark btn btn-info mb-2" to="/update-profile">UPDATE YOUR PROFILE</Link>
                    <button type="button" onClick={handleDeleteProfile} className="btn btn-danger">DELETE YOUR PROFILE <br /> No way back!</button>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}


